import { AddressForm, contactFormFieldsInitialValues } from "Shared/AddressForm/AddressForm";

export function AddAddress() {
  return <AddressForm heading="Add New Address" initialValues={contactFormFieldsInitialValues} />;
}
